import {createSlice, nanoid, PayloadAction} from '@reduxjs/toolkit';

interface Folder {
  name: string;
  id: string;
  date: string;
  isDefault: boolean;
}

export const foldersSlice = createSlice({
  name: 'folders',
  initialState: [
    {
      name: 'Default',
      id: nanoid(),
      date: new Date().toISOString(),
      isDefault: true
    } as Folder
  ],
  reducers: {
    addFolder: {
      reducer: (state, action: PayloadAction<Folder>) => {
        state.push(action.payload);
      },
      prepare: (name: string) => {
        const id = nanoid();
        const date = new Date().toISOString();
        return {payload: {id, name, date, isDefault: false}};
      }
    },
    deleteFolder: (state, action) =>
      state.filter(folder => folder.id !== action.payload || folder.isDefault),
    renameFolder: (state, action) => {
      const folder = state.find(folder => folder.id === action.payload.id);

      if (folder) {
        folder.name = action.payload.name;
      }
    }
  }
});

export const {
  addFolder,
  deleteFolder,
  renameFolder
} = foldersSlice.actions;
export default foldersSlice.reducer;

export const selectDefaultFolder = state =>
  state.folders.find(folder => folder.isDefault);

export const selectNonDefaultFolderConditional = condition => state =>
  state.folders.filter(folder => !folder.isDefault || condition);

export const selectNonDefaultFolders = state =>
  state.folders.filter(folder => !folder.isDefault);
